import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=67608908&scoped=true&"
import script from "./UserPanel.vue?vue&type=script&lang=js&"
export * from "./UserPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=67608908&prod&scoped=true&lang=css&"
import style1 from "./UserPanel.vue?vue&type=style&index=1&id=67608908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67608908",
  null
  
)

export default component.exports